import { render, staticRenderFns } from "./HeaderPageDetail.vue?vue&type=template&id=47d450bf&scoped=true"
import script from "./HeaderPageDetail.vue?vue&type=script&lang=js"
export * from "./HeaderPageDetail.vue?vue&type=script&lang=js"
import style0 from "./HeaderPageDetail.vue?vue&type=style&index=0&id=47d450bf&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d450bf",
  null
  
)

export default component.exports